{
	"id": 7819580,
	"numericId": 7819580,
	"collectionId": 790,
	"status": "ACTIVE",
	"sessionTime": 0,
	"startTime": "2026-05-20T06:08:40.381Z",
	"examBreak": null,
	"timeAllocation": null,
	"progressList": [],
	"sessionItems": [
		{
			"id": 103750,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"overview": {
					"title": "Ethical Decision Making for the Professional Educator",
					"summary": "This module contains one scenario with three different outcomes and a five-question end-of-module knowledge check. It will take approximately 40 to 50 minutes to complete the entire module.",
					"moduleNumber": 8,
					"activityCount": 1,
					"knowledgeCheckCount": 5,
					"estimatedDurationMinutes": 45
				},
				"moduleOutline": {
					"heading": "Module Outline",
					"sections": [
						{
							"title": "Multiple Possible Outcomes of an Ethical Scenario"
						},
						{
							"items": [
								{
									"icon": "square-pen",
									"title": "Outcome 1: Reflect"
								},
								{
									"icon": "compass",
									"title": "Outcome 1: Explore"
								},
								{
									"icon": "clipboard-check",
									"title": "Outcome 1: Review"
								}
							],
							"title": "The Ride Home: Outcome 1"
						},
						{
							"items": [
								{
									"icon": "square-pen",
									"title": "Outcome 2: Reflect"
								},
								{
									"icon": "compass",
									"title": "Outcome 2: Explore"
								},
								{
									"icon": "clipboard-check",
									"title": "Outcome 2: Review"
								}
							],
							"title": "The Ride Home: Outcome 2"
						},
						{
							"items": [
								{
									"icon": "square-pen",
									"title": "Outcome 3: Reflect"
								},
								{
									"icon": "compass",
									"title": "Outcome 3: Explore"
								},
								{
									"icon": "clipboard-check",
									"title": "Outcome 3: Review"
								}
							],
							"title": "The Ride Home: Outcome 3"
						},
						{
							"title": "The Ride Home: Analysis"
						},
						{
							"title": "Module 8 Summary"
						}
					]
				},
				"learningObjectives": {
					"heading": "Learning Objectives",
					"objectives": [
						"Differentiating between dispositional and regulatory frameworks and identifying how each influences educators’ decision making in real‑world scenarios",
						"Identifying how educator actions can produce different short-term and long-term outcomes",
						"Recognizing that a single decision may cause multiple ethical principles to be compromised or upheld",
						"Using ethical principles to evaluate educator responses to situations"
					]
				}
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "module_intro",
				"language": "en-US",
				"position": 1,
				"sourceId": 8010
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103751,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will consider a scenario involving ethical decisions that educators encounter as they interact with students in everyday situations.\n\nAs you evaluate this scenario, your goal is not to determine the single “right” answer. Instead, you are asked to slow down your decision making and thoughtfully consider how different choices could lead to different consequences for the student, for yourself, and for the school community.\n\nHere are steps to help you explore the scenario.",
				"steps": [
					{
						"title": "**Step 1: Envision Short-Term Outcomes for Each Action**",
						"description": "For each possible action, consider what might happen immediately.\n- How could the student be affected right away?\n- How might others perceive the educator’s decision?\n- What practical or emotional consequences could occur that same day?\nThinking through short-term outcomes helps you move beyond instinctive reactions and recognize that even well-meaning choices can carry risks."
					},
					{
						"title": "**Step 2: Envision Long-Term and Ripple Effects**",
						"description": "Now, extend your thinking further by asking the following questions.\n- How could this decision affect professional boundaries over time?\n- What precedent might it set for future interactions?\n- How could this action affect the educator’s professional reputation or licensure if questioned later?\nEthical decision making requires attention to patterns and precedents, not just isolated moments."
					},
					{
						"title": "**Step 3: Connect Outcomes to Professional Standards**",
						"description": "After exploring outcomes, reflect on how each possible action aligns, or conflicts, with the following.\n- Your state’s code of conduct\n- School or district expectations\n- *The Model Code of Ethics for Educators* (*MCEE*), particularly standards related to student welfare and professional boundaries\nThis step reinforces that ethical codes are tools for reflection and justification, not checklists that automatically supply answers."
					},
					{
						"title": "**Step 4: Reflect on What You Learned**",
						"description": "Finally, reflect on the process itself.\n- Which possible outcome surprised you most?\n- How did considering multiple outcomes change your initial reaction?\n- What strategies could help you pause and reflect in a similar real-life situation?\nThe purpose of this exercise is to strengthen your ability to anticipate consequences before acting, especially in moments that feel urgent or emotionally charged."
					}
				],
				"title": "Multiple Possible Outcomes of an Ethical Scenario",
				"instruction": "**Directions:** Select each of the following expandable text buttons to review the steps."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_presentation",
				"language": "en-US",
				"position": 2,
				"sourceId": 8020
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103752,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "The first step in navigating ethical dilemmas is to understand how your values and dispositions can affect your decisions. Educators’ decisions are influenced by two frameworks: dispositional and regulatory. The influence of each framework varies, and educators can be influenced more strongly by one framework than by another. Reflect on what influenced Mr. Morales’ decisions regarding his interactions with Jordan.",
				"title": "Outcome 1: Reflect",
				"question": "Was Mr. Morales influenced more by his dispositional framework or the regulatory framework?",
				"instruction": "**Directions:** Select each of the following two frameworks to read its definition. Then answer the question by choosing one of the frameworks and selecting Submit. If needed, you can try again and select the alternative framework to reveal the explanation."
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "scenario_reflect_framework_choice",
				"language": "en-US",
				"position": 4,
				"sourceId": 8040
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "d294f760-a3f8-495c-995f-645a9ec17519",
						"isCorrect": true
					},
					{
						"choiceId": "ada4e9d7-4636-40c8-ad54-f13267e5b851",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "d294f760-a3f8-495c-995f-645a9ec17519",
					"detailed": {
						"text": "Mr. Morales was influenced more by his dispositional framework than by the regulatory framework. Mr. Morales’ actions reflect a decision influenced primarily by personal values and emotions, rather than by formal rules or procedures. Mr. Morales can tell that Jordan is anxious. He is concerned for Jordan’s safety and uncomfortable with leaving her alone. He acts quickly to resolve the situation without pausing to involve others or consult guidelines. He asks Jordan not to tell anyone, suggesting awareness that his choice may conflict with professional expectations."
					},
					"language": "en-US"
				},
				{
					"type": "STATIC",
					"choiceId": "ada4e9d7-4636-40c8-ad54-f13267e5b851",
					"detailed": {
						"text": "While regulatory guidance, such as school policies, expectations about supervision, or procedures for student safety during after-school hours, was likely available, Mr. Morales’ behavior does not demonstrate active reliance on those structures."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "d294f760-a3f8-495c-995f-645a9ec17519",
						"icon": "heart-handshake",
						"text": "Influenced More by Dispositional Framework",
						"description": "The personal and professional attitudes, values, and beliefs that inform a professional educator’s decision making.",
						"numFirstSelections": 0
					},
					{
						"id": "ada4e9d7-4636-40c8-ad54-f13267e5b851",
						"icon": "scale",
						"text": "Influenced More by Regulatory Framework",
						"description": "School or district policies, state statutes, and criminal laws that form the basis for conduct absolutes and inform a professional educator’s decision making.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false
			},
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103753,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "You will review two videos that show an educator’s interaction with a student and what happens because of the educator’s choices.\n\nAfter observing the videos, you will reflect on and explore the ethical dilemmas depicted in the scenario.",
				"media": [
					{
						"type": "VIDEO",
						"title": "Giving Jordan a Ride Home",
						"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-8/m8o1_giving_ride.mp4",
						"transcript": "**Module 8 – The Ride Home: Outcome 1**\n\n**Video 1: Giving Jordan a Ride Home**\n\nThe video shows two scenes. The first scene takes place at a high school sports complex at night. A teacher is standing out front after locking up.\n\nMr. Morales: [voiceover]. It’s later than I expected. The weather delays pushed the track event back, and now everyone else has already left.\n\n[A student approaches Mr. Morales.]\n\nJordan [anxiously]: My ride never showed up. I’ve been calling my mom, but she’s not answering. I don’t know what to do. All my friends already left. Can you help me get home?\n\nMr. Morales: Jordan, I don’t want you to be stuck here this late. There’s no public transportation around here at night. I can give you a ride home.\n\nJordan: Thank you. I didn’t know what else to do.\n\nThe second scene takes place in Mr. Morales’ car. Mr. Morales is driving and Jordan is sitting in the passenger seat.\n\nMr. Morales: I know this probably isn’t what the handbook says, but I’m just trying to make sure you get home safe. We’ll head straight to your house.\n\n[Jordan smiles.]\n\nMr. Morales [after a long pause]: Jordan, I don’t think anyone saw us leave tonight. It’s probably best not to mention this to anyone, okay?\n\nJordan: Okay.\n\nMr. Morales: Here’s your house. Take care.\n\n[Jordan exits the car. Mr. Morales waits as Jordan walks up to her house.]\n\nMr. Morales [talking to himself]: She’s home safe. I did the right thing, didn’t I?",
						"transcriptTitle": "Transcript for Giving Jordan a Ride Home video",
						"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
					},
					{
						"type": "VIDEO",
						"title": "Jordan’s Mother’s Perspective",
						"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-8/m8o1_mother_perspective.mp4",
						"transcript": "**Module 8 – The Ride Home: Outcome 1**\n\n**Video 2: A Mother’s Suspicion**\n\nThe video shows Jordan’s mother arriving home later that evening. She has a conversation with Jordan.\n\nMother: Jordan? I’m home.\n\n[Jordan joins her mother in the dining area.]\n\nMother: I’m sorry I missed your calls. I tried calling you back when I left work. Is everything OK?\n\nJordan: My ride didn’t show up.\n\nMother: How did you get home tonight?\n\nJordan: I just walked.\n\nMother: You walked? From the school? That’s pretty far, and it was dark.\n\nJordan: I was fine.\n\nMother: Okay. . . . Let me check something.\n\n[Jordan’s mother opens an app on her phone and watches footage from their doorbell camera. The footage shows Jordan walking up to the house as a car pulls away.]\n\nMother: Jordan, that’s not you walking home. Whose car is that?\n\nJordan: I didn’t want you to be mad.\n\nMother: Jordan. Tell me the truth.\n\nJordan: Mr. Morales drove me home.\n\nMother [surprised]: Your teacher? Was anyone else there?\n\nJordan: No. And he said it was probably best not to tell anyone.\n\nMother: Jordan, I’m glad you’re safe. But it shouldn’t have happened like that.\n\nJordan: He was just trying to help.\n\nMother: I understand that. But adults, especially teachers, have rules they’re supposed to follow.\n\n[Jordan’s mother looks at her phone.]\n\nMother: This could have gone very differently.",
						"transcriptTitle": "Transcript for Jordan’s Mother’s Perspective video",
						"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
					}
				],
				"title": "The Ride Home: Outcome 1",
				"instruction": "**Directions:** Select each of the following two tabs to review the two videos. Select the play button in each tab to begin. Use the video controls when needed."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_presentation",
				"language": "en-US",
				"position": 3,
				"sourceId": 8030
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103754,
			"versionId": 1,
			"blockId": null,
			"type": "SATA",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "The second step in navigating ethical dilemmas is exploring the risks to the ethical principles.",
				"title": "Outcome 1: Explore",
				"question": "Which of the following ethical principles were at immediate risk for Mr. Morales? Select all that apply.",
				"instruction": "**Directions:** Select each of the following nine expandable text buttons to review information about each principle of ethical decision making.",
				"ethicalPrinciples": {
					"items": [
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-01-promoting-solution-discovery-illustration-v2.png"
								}
							],
							"title": "**P**romoting Solution Discovery",
							"description": "Creating opportunities for self-advocacy and problem resolution is a foundational principle in ethical decision making. Educators should refer students or colleagues to suitable school resources and officials and ensure that these students and colleagues follow up, rather than handle issues themselves. Not only is this in the best interest of those involved, but it also allows situations to be handled objectively and avoids blurring the scope of the educator’s position with that of more expansive roles such as those of counselor, confidant, caregiver, and rescuer. The primary role of the professional educator is most often associated with the tasks of teaching and learning.\n\n**Guiding Questions**\n- What are the inherent professional risks in attempting to fix the immediate or long-term challenges, problems, and obstacles that students, colleagues, or other learning community stakeholders encounter?\n- Am I accepting responsibilities, performing duties, or providing services that correspond with my training and area of certification?\n- How can I help colleagues when their role as a professional educator overlaps with other societal expectations?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-02-risk-mitigation-illustration-v2.png"
								}
							],
							"title": "**R**isk Mitigation",
							"description": "Since educators provide services directly to minors who remain under their care and supervision for extended periods of time without the presence of parents or guardians, the field of education has many professional risks and vulnerabilities. It is important that all educators continually reflect on how to best mitigate risks that may compromise their professional and personal credibility, career goals, personal well-being, and effectiveness as a teacher.\n\n**Guiding Questions**\n- How can a seemingly innocuous and insignificant decision have the potential to put my educational practice at risk?\n- What professional-risk situations inherent in my educational practice do I need to carefully consider (for example, chaperoning an overnight field trip, being approached by a student for personal advice)?\n- What conversations can I have with my colleagues to help identify ways to mitigate risks in situations that we commonly encounter?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-03-objectivity-neutrality-maintained-illustration-v3.png"
								}
							],
							"title": "**O**bjectivity and Neutrality Are Maintained",
							"description": "By maintaining objectivity and neutrality, professional educators should be able to evaluate a situation without emotional entanglements or bias. Remaining objective and neutral mitigates the risks of over-identifying with one party, becoming too focused on the needs of an individual, or advocating for a singular interest instead of advocating for solutions.\n\n**Guiding Questions**\n- When encountering competing tensions (for example, school policy versus what I think is best for a student or colleague; parental influence versus administrative influence), how can I determine the best course of action?\n- How can I remain objective and neutral when I have multiple relationships in the schooling community and as a community member (for example, I’m a friend of one of my student’s parents; I am a youth group leader at a student’s religious center; I coach a student on a club volleyball team during the summer)?\n- How can I best caution a colleague if I suspect the colleague is becoming overwhelmed by the needs of a student?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-04-ensuring-student-welfare-illustration-v2.png"
								}
							],
							"title": "**E**nsuring Student Welfare",
							"description": "Since the individuals receiving services are minors and the educators have been ascribed in loco parentis responsibilities, the primary responsibility of educators is to ensure the students’ safety and welfare. The scope of this charge is not just limited to physical safety, but it also includes emotional, intellectual, psychological, and sexual safety.\n\n**Guiding Questions**\n- Am I doing everything in my power to establish a safe and secure environment for academic, personal, and social growth to occur?\n- Am I willing to safeguard students from duress even if I am not directly responsible for the students?\n- How can I best confront a colleague regarding acts, either committed or omitted, that have the potential to compromise a student’s welfare?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-05-transparency-actions-communications-illustration-v2.png"
								}
							],
							"title": "**T**ransparency in Actions and Communications",
							"description": "Educators must be transparent in their actions and communications. Transparency establishes openness, accountability, trust, credibility, and boundaries. Failure to be sufficiently transparent with appropriate stakeholders (for example, parents, guardians, students, colleagues, administrators) may result in misinterpretation of motives or the appearance of impropriety. Transparency is the best way for educators to ensure that their decisions and behaviors can withstand public scrutiny.\n\n**Guiding Questions**\n- How can I ensure that all communications with students, including digital and electronic communications, are conducted with transparency?\n- How can I balance the need for transparency in my actions and communications with protecting highly confidential information that I am expected to retain (which is considered a “qualified privilege” by the courts)?\n- How do I best approach a colleague about rumors of impropriety that are a result of their lack of transparency in decision making?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-06-boundaries-role-time-place-illustration-v2.png"
								}
							],
							"title": "**H**onoring the Boundaries of Role, Time, and Place",
							"description": "Boundaries encompass the verbal, physical, emotional, and social distances that an educator must maintain to ensure security, structure, and predictability in an educational environment. Most often, the boundaries that are transgressed relate to role, time, and place. By respecting the functions and limits of contracted roles, as well as the working hours and location of the learning environment, secure boundaries are in place for all members of the school community.\n\n**Guiding Questions**\n- In reflecting on my educational practice, which dispositions most risk eroding professional boundaries (for example, assisting with students’ personal challenges, extending academic support beyond school hours, engaging in extracurricular activities, communication with students, parents, and colleagues)?\n- Am I thinking about all my interactions with students (for example, in the school, in the community, and at social functions) as an extension of my professional responsibilities as an educator?\n- How can my colleagues and I openly discuss and agree on boundaries that are most appropriate for our educational context?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-07-integrity-profession-illustration-v2.png"
								}
							],
							"title": "**I**ntegrity of the Profession Is Promoted by the Educator",
							"description": "Educators’ actions reflect on the schooling community, the district, and the profession. An individual educator’s positive actions have the potential to inspire public confidence in the profession. On the other hand, negative actions can cast shadows of doubt and distrust by undermining the effectiveness of a healthy educational structure. The professional educator has an obligation to hold himself or herself responsible for ethical conduct. The educator should take steps when he or she has reason to believe that another educator may be approaching or engaged in an ethically compromising situation.\n\n**Guiding Questions**\n- How often am I reflecting on the daily decisions that I make as a professional educator and how those decisions may affect the integrity of the profession?\n- What steps can I take when I believe that a colleague may be approaching or involved in an ethically compromising situation?\n- How can I best advocate for the profession while also working to reconcile points of disagreement within the school or district?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-08-code-ethics-fidelity-illustration-v2.png"
								}
							],
							"title": "**C**ode of Ethics for Educators Is Maintained with Fidelity",
							"description": "Having an ethics code is a proclamation that a profession is better off when ethical standards are not based solely on individual assessments of what is or is not ethically acceptable but reflect consensus among members on a common purpose. For the education discipline, the *Model Code of Ethics for Educators* (*MCEE*) is a guide for what educators should expect of themselves and one another and should be maintained with fidelity. The *MCEE* assists educators in their efforts to resolve ethical dilemmas and helps educators defend their decisions to schooling-community constituents, institutions, courts, and any other agency that would encourage them to go against the values of the profession. The formal standards are not a substitute for an active, deliberate, and creative approach to fulfilling your ethical responsibilities. They prompt, guide, and inform an educator’s ethical decision-making; they do not serve as a substitute for it.\n\n**Guiding Questions**\n- How can educators from my school or district work together to identify common ethical dilemmas that we encounter?\n- Is there a way to use the *MCEE* as a prompt to discuss resolutions to those ethical dilemmas?\n- Since ethical dilemmas are often situational, contextual, and likely to change over time, how can the *MCEE* continue to guide and inform my decision making as I engage in the practical realities of my work?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"
								}
							],
							"title": "**S**tewardship of the Law and Public Trust",
							"description": "Employment policies, licensure statutes, and community laws represent conduct absolutes that have originated from a history of judicial activity. They represent the lowest standard of acceptable behavior deemed necessary to safeguard community members. However, the professional educator is aware that trust in the profession depends on a level of conduct and responsibility that may be higher than what is required by law.\n\n**Guiding Questions**\n- How will relevant procedures, policies, and laws inform my decision making when I encounter ethical dilemmas?\n- It has been said that misconduct is not an event but a process. Will I be able to identify those situations where a series of gradual and unintentional missteps could lead to the transgression of a conduct absolute?\n- What steps can I take when I believe that a colleague may be approaching or involved in actions that may lead to the transgression of a policy, statute, or law?"
						}
					],
					"title": "Ethical Principles"
				}
			},
			"metadata": {
				"type": "SATA",
				"ui_type": "scenario_principle_sata_activity",
				"language": "en-US",
				"position": 5,
				"sourceId": 8050
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "b5b1312c-11bd-471b-b059-01ea31164899",
						"isCorrect": true
					},
					{
						"choiceId": "95be9325-91d9-4dfc-bf73-ce6767087d5d",
						"isCorrect": true
					},
					{
						"choiceId": "760c16a1-acc3-49cc-afc3-1835b692d043",
						"isCorrect": true
					},
					{
						"choiceId": "1cd763ad-6249-4733-8ed3-263d800637ea",
						"isCorrect": true
					},
					{
						"choiceId": "0c69eb7b-3db8-4001-be6e-4b6396f8d009",
						"isCorrect": true
					},
					{
						"choiceId": "d576a7c4-898b-4138-9024-1b63afeeaac7",
						"isCorrect": true
					},
					{
						"choiceId": "e7517c4a-77a2-420d-984c-97a6992eda91",
						"isCorrect": true
					},
					{
						"choiceId": "5e99f5b3-fda6-45b7-a2de-d5058f901837",
						"isCorrect": true
					},
					{
						"choiceId": "141fa4c1-50ce-4a34-bcc0-1a74c5079c30",
						"isCorrect": true
					}
				],
				"selection": {
					"max": 9,
					"min": 1
				}
			},
			"feedback": null,
			"response": {
				"type": "MULTIPLE_SELECT",
				"choices": [
					{
						"id": "b5b1312c-11bd-471b-b059-01ea31164899",
						"text": "Promoting Solution Discovery",
						"numFirstSelections": 0
					},
					{
						"id": "95be9325-91d9-4dfc-bf73-ce6767087d5d",
						"text": "Risk Mitigation",
						"numFirstSelections": 0
					},
					{
						"id": "760c16a1-acc3-49cc-afc3-1835b692d043",
						"text": "Objectivity and Neutrality Are Maintained",
						"numFirstSelections": 0
					},
					{
						"id": "1cd763ad-6249-4733-8ed3-263d800637ea",
						"text": "Ensuring Student Welfare",
						"numFirstSelections": 0
					},
					{
						"id": "0c69eb7b-3db8-4001-be6e-4b6396f8d009",
						"text": "Transparency in Actions and Communications",
						"numFirstSelections": 0
					},
					{
						"id": "d576a7c4-898b-4138-9024-1b63afeeaac7",
						"text": "Honoring the Boundaries of Role, Time, and Place",
						"numFirstSelections": 0
					},
					{
						"id": "e7517c4a-77a2-420d-984c-97a6992eda91",
						"text": "Integrity of the Profession Is Promoted by the Educator",
						"numFirstSelections": 0
					},
					{
						"id": "5e99f5b3-fda6-45b7-a2de-d5058f901837",
						"text": "Code of Ethics for Educators Is Maintained with Fidelity",
						"numFirstSelections": 0
					},
					{
						"id": "141fa4c1-50ce-4a34-bcc0-1a74c5079c30",
						"text": "Stewardship of the Law and Public Trust",
						"numFirstSelections": 0
					}
				],
				"shuffle": false
			},
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103755,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Review the ethical principles to determine whether each ethical principle was at immediate risk for Mr. Morales.",
				"items": [
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Mr. Morales handled the situation independently rather than referring Jordan to appropriate school resources or involving an administrator. In doing so, Mr. Morales did not allow Jordan the opportunity to engage in supported problem resolution and self‑advocacy."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-01-promoting-solution-discovery-illustration-v2.png"
								}
							],
							"title": "Promoting Solution Discovery"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "By transporting Jordan alone in his personal vehicle and asking for secrecy, Mr. Morales increased professional and personal risk. He should have tried mitigating risk through transparency, documentation, or shared responsibility."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-02-risk-mitigation-illustration-v2.png"
								}
							],
							"title": "Risk Mitigation"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Mr. Morales allowed empathy and urgency to outweigh objective evaluation of the situation, leading him to act quickly to address Jordan’s immediate need rather than take the time to consider alternative, institutionally supported solutions."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-03-objectivity-neutrality-maintained-illustration-v3.png"
								}
							],
							"title": "Objectivity and Neutrality Are Maintained"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Although Jordan’s physical safety was addressed, her broader welfare was placed at risk because she felt pressure to lie to her parent and must now navigate the emotional consequences of secrecy involving an authority figure."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-04-ensuring-student-welfare-illustration-v2.png"
								}
							],
							"title": "Ensuring Student Welfare"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Requesting that Jordan not tell anyone about the ride directly undermined transparency and accountability, creating the appearance of impropriety once the action was later discovered."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-05-transparency-actions-communications-illustration-v2.png"
								}
							],
							"title": "Transparency in Actions and Communications"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Providing a private ride after school hours, off the school’s property, and outside formal supervision blurred professional boundaries related to role and setting, placing Mr. Morales in a caregiver role beyond his professional scope."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-06-boundaries-role-time-place-illustration-v2.png"
								}
							],
							"title": "Honoring the Boundaries of Role, Time, and Place"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Mr. Morales’ behavior illustrates how individual actions can reflect on the profession. When Jordan told her mother what happened, it was made clear that Mr. Morales’ decision risked eroding parental trust and public confidence."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-07-integrity-profession-illustration-v2.png"
								}
							],
							"title": "Integrity of the Profession Is Promoted by the Educator"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Mr. Morales relied on personal judgment rather than ethical standards or established procedures, demonstrating how ethical codes lose effectiveness when not actively consulted during real‑time decision making."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-08-code-ethics-fidelity-illustration-v2.png"
								}
							],
							"title": "Code of Ethics for Educators Is Maintained with Fidelity"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "While no immediate legal violation is shown, the secrecy and lack of procedural adherence created conditions where policy or statutory concerns could easily emerge, threatening public trust in educator conduct."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"
								}
							],
							"title": "Stewardship of the Law and Public Trust"
						}
					}
				],
				"title": "Outcome 1: Review",
				"instruction": "**Directions:** Select each of the following nine flip cards to explore whether each ethical principle was at immediate risk for Mr. Morales. Each of the nine cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_principle_review_cards",
				"language": "en-US",
				"position": 6,
				"sourceId": 8060
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103756,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Review the ethical principles to determine whether each ethical principle was at immediate risk for Mr. Morales.",
				"items": [
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Mr. Morales redirected the problem to Jordan rather than connecting her to appropriate school resources or officials, limiting her access to support that could help with problem resolution and placing responsibility on a minor to navigate a difficult situation alone."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-01-promoting-solution-discovery-illustration-v2.png"
								}
							],
							"title": "Promoting Solution Discovery"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Although Mr. Morales avoided personal liability, he did not adequately assess or mitigate the foreseeable risks Jordan might encounter in an unsupervised public setting late at night."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-02-risk-mitigation-illustration-v2.png"
								}
							],
							"title": "Risk Mitigation"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Mr. Morales prioritized avoiding personal risk over making a balanced evaluation of student safety. Because he was focused on regulatory caution, he did not neutrally assess the broader situation and its potential consequences."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-03-objectivity-neutrality-maintained-illustration-v3.png"
								}
							],
							"title": "Objectivity and Neutrality Are Maintained"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "By sending Jordan alone to a public location without supervision, Mr. Morales placed her safety at risk, as evidenced by her exposure to intimidation and her distress."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-04-ensuring-student-welfare-illustration-v2.png"
								}
							],
							"title": "Ensuring Student Welfare"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Mr. Morales did not involve parents, administrators, or colleagues in the decision, which did not promote shared accountability or transparency for Jordan’s after‑school supervision."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-05-transparency-actions-communications-illustration-v2.png"
								}
							],
							"title": "Transparency in Actions and Communications"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "While Mr. Morales maintained personal boundaries by declining to transport Jordan, he failed to fully uphold his supervisory role by leaving Jordan alone before ensuring a safe, supported transition of care."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-06-boundaries-role-time-place-illustration-v2.png"
								}
							],
							"title": "Honoring the Boundaries of Role, Time, and Place"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "The outcome illustrates how decisions that prioritize self‑protection over adequate assessment of student safety can undermine public confidence in educators’ commitment to student welfare."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-07-integrity-profession-illustration-v2.png"
								}
							],
							"title": "Integrity of the Profession Is Promoted by the Educator"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Mr. Morales appeared to rely on a narrow interpretation of boundaries rather than using an ethics code as a guide to collaborative, student‑centered problem-solving."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-08-code-ethics-fidelity-illustration-v2.png"
								}
							],
							"title": "Code of Ethics for Educators Is Maintained with Fidelity"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Although no laws were violated, the situation demonstrates how minimal compliance with rules may fall short of the higher standard of care expected to maintain public trust."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"
								}
							],
							"title": "Stewardship of the Law and Public Trust"
						}
					}
				],
				"title": "Outcome 2: Review",
				"instruction": "**Directions:** Select each of the following nine flip cards to explore whether each ethical principle was at immediate risk for Mr. Morales. Each of the nine cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_principle_review_cards",
				"language": "en-US",
				"position": 10,
				"sourceId": 8100
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103757,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "You will review two videos that show an educator’s interaction with a student and what happens because of the educator’s choices.\n\nAfter observing the videos, you will reflect on and explore the ethical dilemmas depicted in the scenario.",
				"media": [
					{
						"type": "VIDEO",
						"title": "Declining to Give Jordan a Ride",
						"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-8/m8o2_declining_ride.mp4",
						"transcript": "**Module 8 – The Ride Home: Outcome 2**\n\n**Video 1: Declining to Give Jordan A Ride**\n\nThe video shows two scenes. The first scene takes place at a high school sports complex at night. A teacher is standing out front after locking up.\n\nMr. Morales: [voiceover] It’s later than I expected. The weather delays pushed the track event back, and now everyone else has already left.\n\n[A student approaches Mr. Morales.]\n\nJordan [anxiously]: My ride never showed up. I’ve been calling my mom, but she’s not answering. I don’t know what to do. All my friends already left. Can you help me get home?\n\nMr. Morales: I’m really sorry, but I can’t drive you home.\n\nJordan: Oh . . . okay.\n\nMr. Morales: I can’t leave you here, but I also can’t take you by myself. There’s a convenience store down the street that stays open late.\n\nJordan: You want me to walk there?\n\nMr. Morales: It’s well lit, and there are people around. You can wait inside and keep trying to reach your mom.\n\nJordan: Alright.\n\nThe second scene shows Jordan walking to the convenience store and entering it by herself.\n\nThe video switches back to show Mr. Morales still standing in front of the sports complex.\n\nMr. Morales [voiceover]: She’ll be safer there than here, right?",
						"transcriptTitle": "Transcript for Declining to Give Jordan a Ride video",
						"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
					},
					{
						"type": "VIDEO",
						"title": "The Convenience Store",
						"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-8/m8o2_convenience_store.mp4",
						"transcript": "**Module 8 – The Ride Home: Outcome 2**\n\n**Video 2: The Convenience Store**\n\nThe video shows Jordan entering the convenience store. Two older male high school students are there. Student #1 smirks at Jordan.\n\nStudent #1: Hey, isn’t that one of the freshmen?\n\n[Jordan stops.]\n\nStudent #2 [Snarky]: Where are you headed all by yourself?\n\nJordan: Just waiting for my ride.\n\nStudent #1: Sure you are. Why don’t you come over here and talk to us?\n\n[Student #2 laughs. Jordan looks down and crosses her arms.]\n\nJordan goes into the restroom and closes the door. She pulls out her phone. She calls her mother.\n\nJordan: Mom . . . please answer . . .\n\nJordan’s Mother: Jordan? I just saw your calls. Where are you?\n\nJordan: I’m at the convenience store near the school. Some kids here are bothering me. I’m hiding in the restroom.\n\nJordan’s Mother: Stay there. I’m on my way right now.\n\nJordan: Okay. I’ll wait.",
						"transcriptTitle": "Transcript for The Convenience Store video",
						"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
					}
				],
				"title": "The Ride Home: Outcome 2",
				"instruction": "**Directions:** Select each of the following two tabs to review the two videos. Select the play button in each tab to begin. Use the video controls when needed."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_presentation",
				"language": "en-US",
				"position": 7,
				"sourceId": 8070
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103758,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "The first step in navigating ethical dilemmas is to understand how your values and dispositions can affect your decisions. Educators’ decisions are influenced by two frameworks: dispositional and regulatory. The influence of each framework varies, and educators can be influenced more strongly by one framework than by another. Reflect on what influenced Mr. Morales’ decisions regarding his interactions with Jordan in this last scenario.",
				"title": "Outcome 3: Reflect",
				"question": "Was Mr. Morales influenced more by his dispositional framework or the regulatory framework?",
				"instruction": "**Directions:** Select each of the following two frameworks to read its definition. Then answer the question by choosing one of the frameworks and selecting Submit. If needed, you can try again and select the alternative framework to reveal the explanation."
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "scenario_reflect_framework_choice",
				"language": "en-US",
				"position": 12,
				"sourceId": 8120
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "06a03bee-c65d-4110-9203-be864cb4c134",
						"isCorrect": false
					},
					{
						"choiceId": "525d660c-d701-4169-a013-f462bfe99987",
						"isCorrect": true
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "06a03bee-c65d-4110-9203-be864cb4c134",
					"detailed": {
						"text": "Mr. Morales was influenced more by the regulatory framework than by his dispositional framework. While Mr. Morales’ decision is mostly based on regulatory thinking, dispositional influences are still evident in his response to Jordan. He reassures Jordan and remains present, demonstrating care and professionalism."
					},
					"language": "en-US"
				},
				{
					"type": "STATIC",
					"choiceId": "525d660c-d701-4169-a013-f462bfe99987",
					"detailed": {
						"text": "Mr. Morales’ decisions in this outcome are deliberately aligned with following school procedures, maintaining professional boundaries, and fostering shared accountability. Mr. Morales stays with Jordan rather than acting independently or disengaging, so he fulfills his supervisory responsibility. He attempts to contact a parent or emergency contact before taking further action, which is consistent with expected protocols. He contacts an administrator and waits for support rather than transporting the student alone. The administrator’s involvement in transporting Jordan home and the fact that the situation will be documented create transparency and provide institutional oversight."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "06a03bee-c65d-4110-9203-be864cb4c134",
						"icon": "heart-handshake",
						"text": "Influenced More by Dispositional Framework",
						"description": "The personal and professional attitudes, values, and beliefs that inform a professional educator’s decision making.",
						"numFirstSelections": 0
					},
					{
						"id": "525d660c-d701-4169-a013-f462bfe99987",
						"icon": "scale",
						"text": "Influenced More by Regulatory Framework",
						"description": "School or district policies, state statutes, and criminal laws that form the basis for conduct absolutes and inform a professional educator’s decision making.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false
			},
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103759,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "The first step in navigating ethical dilemmas is to understand how your values and dispositions can affect your decisions. Educators’ decisions are influenced by two frameworks: dispositional and regulatory. The influence of each framework varies, and educators can be influenced more strongly by one framework than by another. Reflect on what influenced Mr. Morales’ decisions regarding his interactions with Jordan in this alternate scenario.",
				"title": "Outcome 2: Reflect",
				"question": "Was Mr. Morales influenced more by his dispositional framework or the regulatory framework?",
				"instruction": "**Directions:** Select each of the following two frameworks to read its definition. Then answer the question by choosing one of the frameworks and selecting Submit. If needed, you can try again and select the alternative framework to reveal the explanation."
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "scenario_reflect_framework_choice",
				"language": "en-US",
				"position": 8,
				"sourceId": 8080
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "3d145aef-93c8-4968-8610-0030df9caa65",
						"isCorrect": false
					},
					{
						"choiceId": "8c1cee16-1133-4e6f-9177-b485002e1320",
						"isCorrect": true
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "3d145aef-93c8-4968-8610-0030df9caa65",
					"detailed": {
						"text": "Mr. Morales was influenced more by the regulatory framework than by his dispositional framework. While Mr. Morales’ decision is mostly based on regulatory thinking, dispositional influences are still evident in his expression of concern for Jordan’s safety and his suggestion of going to a nearby public location, which he perceives as a safer alternative."
					},
					"language": "en-US"
				},
				{
					"type": "STATIC",
					"choiceId": "8c1cee16-1133-4e6f-9177-b485002e1320",
					"detailed": {
						"text": "Mr. Morales’ actions indicate that policies, boundaries, and conduct expectations played a greater role in guiding his decision. Mr. Morales clearly states that he cannot provide transportation, demonstrating awareness of professional boundaries related to student supervision and after‑school interactions. He avoids placing himself alone with a student in his personal vehicle, reducing risk related to perception, liability, and boundary violations. These actions suggest that Mr. Morales is consciously attempting to align with school or district expectations and to avoid conduct that could place his professional role at risk."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "3d145aef-93c8-4968-8610-0030df9caa65",
						"icon": "heart-handshake",
						"text": "Influenced More by Dispositional Framework",
						"description": "The personal and professional attitudes, values, and beliefs that inform a professional educator’s decision making.",
						"numFirstSelections": 0
					},
					{
						"id": "8c1cee16-1133-4e6f-9177-b485002e1320",
						"icon": "scale",
						"text": "Influenced More by Regulatory Framework",
						"description": "School or district policies, state statutes, and criminal laws that form the basis for conduct absolutes and inform a professional educator’s decision making.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false
			},
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103760,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Review the ethical principles to determine whether each ethical principle was at immediate risk for Mr. Morales.",
				"items": [
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": "Mr. Morales connects Jordan to an appropriate school official by involving an administrator, modeling problem resolution that relies on institutional support rather than individual intervention."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-01-promoting-solution-discovery-illustration-v2.png"
								}
							],
							"title": "Promoting Solution Discovery"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": "By avoiding independent action and sharing responsibility with an administrator, Mr. Morales minimizes professional, personal, and student risk and ensures that the situation is properly documented and supervised."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-02-risk-mitigation-illustration-v2.png"
								}
							],
							"title": "Risk Mitigation"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": "Mr. Morales balances empathy with professional judgment, remaining present and supportive without allowing emotion or urgency to overinfluence his decision making or cause him to make boundary‑crossing decisions."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-03-objectivity-neutrality-maintained-illustration-v3.png"
								}
							],
							"title": "Objectivity and Neutrality Are Maintained"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": "Jordan’s physical, emotional, and psychological safety are maintained through continuous supervision, adult presence, and the provision of secure, supervised transportation home."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-04-ensuring-student-welfare-illustration-v2.png"
								}
							],
							"title": "Ensuring Student Welfare"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": "The involvement of an administrator and Jordan’s later disclosure to her mother ensure openness and accountability, allowing Mr. Morales’ actions to withstand public and parental scrutiny."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-05-transparency-actions-communications-illustration-v2.png"
								}
							],
							"title": "Transparency in Actions and Communications"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": "Mr. Morales respects professional boundaries by remaining in a supervisory role and avoiding private, after‑school interactions that extend beyond his role or training."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-06-boundaries-role-time-place-illustration-v2.png"
								}
							],
							"title": "Honoring the Boundaries of Role, Time, and Place"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": "By following procedures and modeling ethical decision‑making, Mr. Morales reinforces trust in educators and demonstrates responsible professional conduct."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-07-integrity-profession-illustration-v2.png"
								}
							],
							"title": "Integrity of the Profession Is Promoted by the Educator"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": "Mr. Morales uses ethical standards to actively guide his decision making, demonstrating fidelity to shared professional values and an understanding that relying on personal judgment alone is not sufficient."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-08-code-ethics-fidelity-illustration-v2.png"
								}
							],
							"title": "Code of Ethics for Educators Is Maintained with Fidelity"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": "Mr. Morales proactively protects student welfare and preserves public trust through ensuring shared accountability."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"
								}
							],
							"title": "Stewardship of the Law and Public Trust"
						}
					}
				],
				"title": "Outcome 3: Review",
				"instruction": "**Directions:** Select each of the following nine flip cards to explore whether each ethical principle was at immediate risk for Mr. Morales. Each of the nine cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_principle_review_cards",
				"language": "en-US",
				"position": 14,
				"sourceId": 8140
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103761,
			"versionId": 1,
			"blockId": null,
			"type": "SATA",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "The second step in navigating ethical dilemmas is exploring the risks to the ethical principles.",
				"title": "Outcome 2: Explore",
				"question": "Which of the following ethical principles were at immediate risk for Mr. Morales in this alternate scenario? Select all that apply.",
				"instruction": "**Directions:** Select each of the following nine expandable text buttons to review information about each principle of ethical decision making.",
				"ethicalPrinciples": {
					"items": [
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-01-promoting-solution-discovery-illustration-v2.png"
								}
							],
							"title": "**P**romoting Solution Discovery",
							"description": "Creating opportunities for self-advocacy and problem resolution is a foundational principle in ethical decision making. Educators should refer students or colleagues to suitable school resources and officials and ensure that these students and colleagues follow up, rather than handle issues themselves. Not only is this in the best interest of those involved, but it also allows situations to be handled objectively and avoids blurring the scope of the educator’s position with that of more expansive roles such as those of counselor, confidant, caregiver, and rescuer. The primary role of the professional educator is most often associated with the tasks of teaching and learning.\n\n**Guiding Questions**\n- What are the inherent professional risks in attempting to fix the immediate or long-term challenges, problems, and obstacles that students, colleagues, or other learning community stakeholders encounter?\n- Am I accepting responsibilities, performing duties, or providing services that correspond with my training and area of certification?\n- How can I help colleagues when their role as a professional educator overlaps with other societal expectations?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-02-risk-mitigation-illustration-v2.png"
								}
							],
							"title": "**R**isk Mitigation",
							"description": "Since educators provide services directly to minors who remain under their care and supervision for extended periods of time without the presence of parents or guardians, the field of education has many professional risks and vulnerabilities. It is important that all educators continually reflect on how to best mitigate risks that may compromise their professional and personal credibility, career goals, personal well-being, and effectiveness as a teacher.\n\n**Guiding Questions**\n- How can a seemingly innocuous and insignificant decision have the potential to put my educational practice at risk?\n- What professional-risk situations inherent in my educational practice do I need to carefully consider (for example, chaperoning an overnight field trip, being approached by a student for personal advice)?\n- What conversations can I have with my colleagues to help identify ways to mitigate risks in situations that we commonly encounter?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-03-objectivity-neutrality-maintained-illustration-v3.png"
								}
							],
							"title": "**O**bjectivity and Neutrality Are Maintained",
							"description": "By maintaining objectivity and neutrality, professional educators should be able to evaluate a situation without emotional entanglements or bias. Remaining objective and neutral mitigates the risks of over-identifying with one party, becoming too focused on the needs of an individual, or advocating for a singular interest instead of advocating for solutions.\n\n**Guiding Questions**\n- When encountering competing tensions (for example, school policy versus what I think is best for a student or colleague; parental influence versus administrative influence), how can I determine the best course of action?\n- How can I remain objective and neutral when I have multiple relationships in the schooling community and as a community member (for example, I’m a friend of one of my student’s parents; I am a youth group leader at a student’s religious center; I coach a student on a club volleyball team during the summer)?\n- How can I best caution a colleague if I suspect the colleague is becoming overwhelmed by the needs of a student?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-04-ensuring-student-welfare-illustration-v2.png"
								}
							],
							"title": "**E**nsuring Student Welfare",
							"description": "Since the individuals receiving services are minors and the educators have been ascribed in loco parentis responsibilities, the primary responsibility of educators is to ensure the students’ safety and welfare. The scope of this charge is not just limited to physical safety, but it also includes emotional, intellectual, psychological, and sexual safety.\n\n**Guiding Questions**\n- Am I doing everything in my power to establish a safe and secure environment for academic, personal, and social growth to occur?\n- Am I willing to safeguard students from duress even if I am not directly responsible for the students?\n- How can I best confront a colleague regarding acts, either committed or omitted, that have the potential to compromise a student’s welfare?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-05-transparency-actions-communications-illustration-v2.png"
								}
							],
							"title": "**T**ransparency in Actions and Communications",
							"description": "Educators must be transparent in their actions and communications. Transparency establishes openness, accountability, trust, credibility, and boundaries. Failure to be sufficiently transparent with appropriate stakeholders (for example, parents, guardians, students, colleagues, administrators) may result in misinterpretation of motives or the appearance of impropriety. Transparency is the best way for educators to ensure that their decisions and behaviors can withstand public scrutiny.\n\n**Guiding Questions**\n- How can I ensure that all communications with students, including digital and electronic communications, are conducted with transparency?\n- How can I balance the need for transparency in my actions and communications with protecting highly confidential information that I am expected to retain (which is considered a “qualified privilege” by the courts)?\n- How do I best approach a colleague about rumors of impropriety that are a result of their lack of transparency in decision making?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-06-boundaries-role-time-place-illustration-v2.png"
								}
							],
							"title": "**H**onoring the Boundaries of Role, Time, and Place",
							"description": "Boundaries encompass the verbal, physical, emotional, and social distances that an educator must maintain to ensure security, structure, and predictability in an educational environment. Most often, the boundaries that are transgressed relate to role, time, and place. By respecting the functions and limits of contracted roles, as well as the working hours and location of the learning environment, secure boundaries are in place for all members of the school community.\n\n**Guiding Questions**\n- In reflecting on my educational practice, which dispositions most risk eroding professional boundaries (for example, assisting with students’ personal challenges, extending academic support beyond school hours, engaging in extracurricular activities, communication with students, parents, and colleagues)?\n- Am I thinking about all my interactions with students (for example, in the school, in the community, and at social functions) as an extension of my professional responsibilities as an educator?\n- How can my colleagues and I openly discuss and agree on boundaries that are most appropriate for our educational context?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-07-integrity-profession-illustration-v2.png"
								}
							],
							"title": "**I**ntegrity of the Profession Is Promoted by the Educator",
							"description": "Educators’ actions reflect on the schooling community, the district, and the profession. An individual educator’s positive actions have the potential to inspire public confidence in the profession. On the other hand, negative actions can cast shadows of doubt and distrust by undermining the effectiveness of a healthy educational structure. The professional educator has an obligation to hold himself or herself responsible for ethical conduct. The educator should take steps when he or she has reason to believe that another educator may be approaching or engaged in an ethically compromising situation.\n\n**Guiding Questions**\n- How often am I reflecting on the daily decisions that I make as a professional educator and how those decisions may affect the integrity of the profession?\n- What steps can I take when I believe that a colleague may be approaching or involved in an ethically compromising situation?\n- How can I best advocate for the profession while also working to reconcile points of disagreement within the school or district?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-08-code-ethics-fidelity-illustration-v2.png"
								}
							],
							"title": "**C**ode of Ethics for Educators Is Maintained with Fidelity",
							"description": "Having an ethics code is a proclamation that a profession is better off when ethical standards are not based solely on individual assessments of what is or is not ethically acceptable but reflect consensus among members on a common purpose. For the education discipline, the *Model Code of Ethics for Educators* (*MCEE*) is a guide for what educators should expect of themselves and one another and should be maintained with fidelity. The *MCEE* assists educators in their efforts to resolve ethical dilemmas and helps educators defend their decisions to schooling-community constituents, institutions, courts, and any other agency that would encourage them to go against the values of the profession. The formal standards are not a substitute for an active, deliberate, and creative approach to fulfilling your ethical responsibilities. They prompt, guide, and inform an educator’s ethical decision-making; they do not serve as a substitute for it.\n\n**Guiding Questions**\n- How can educators from my school or district work together to identify common ethical dilemmas that we encounter?\n- Is there a way to use the *MCEE* as a prompt to discuss resolutions to those ethical dilemmas?\n- Since ethical dilemmas are often situational, contextual, and likely to change over time, how can the *MCEE* continue to guide and inform my decision making as I engage in the practical realities of my work?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"
								}
							],
							"title": "**S**tewardship of the Law and Public Trust",
							"description": "Employment policies, licensure statutes, and community laws represent conduct absolutes that have originated from a history of judicial activity. They represent the lowest standard of acceptable behavior deemed necessary to safeguard community members. However, the professional educator is aware that trust in the profession depends on a level of conduct and responsibility that may be higher than what is required by law.\n\n**Guiding Questions**\n- How will relevant procedures, policies, and laws inform my decision making when I encounter ethical dilemmas?\n- It has been said that misconduct is not an event but a process. Will I be able to identify those situations where a series of gradual and unintentional missteps could lead to the transgression of a conduct absolute?\n- What steps can I take when I believe that a colleague may be approaching or involved in actions that may lead to the transgression of a policy, statute, or law?"
						}
					],
					"title": "Ethical Principles"
				}
			},
			"metadata": {
				"type": "SATA",
				"ui_type": "scenario_principle_sata_activity",
				"language": "en-US",
				"position": 9,
				"sourceId": 8090
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "e97cc761-800b-4175-9665-ccf315f1ad1d",
						"isCorrect": true
					},
					{
						"choiceId": "d330a9ed-58b1-4d07-89d2-77f722d7c611",
						"isCorrect": true
					},
					{
						"choiceId": "ebd92289-25f6-4eea-8aa5-c7ca0813d957",
						"isCorrect": true
					},
					{
						"choiceId": "9e5a8480-ad4f-42cf-939a-03dac1f9fb78",
						"isCorrect": true
					},
					{
						"choiceId": "86f03ac2-7fa0-4d13-b873-16f514071ef3",
						"isCorrect": true
					},
					{
						"choiceId": "aae9df86-3dfb-4ef6-9686-3a5e19fb6375",
						"isCorrect": true
					},
					{
						"choiceId": "afa84a0d-bc22-4198-9030-85d3cffb3e1e",
						"isCorrect": true
					},
					{
						"choiceId": "25bd0079-3074-4589-82a5-a1e34d5848c5",
						"isCorrect": true
					},
					{
						"choiceId": "ef057765-9e96-4469-8528-3b03b224b1b5",
						"isCorrect": true
					}
				],
				"selection": {
					"max": 9,
					"min": 1
				}
			},
			"feedback": null,
			"response": {
				"type": "MULTIPLE_SELECT",
				"choices": [
					{
						"id": "e97cc761-800b-4175-9665-ccf315f1ad1d",
						"text": "Promoting Solution Discovery",
						"numFirstSelections": 0
					},
					{
						"id": "d330a9ed-58b1-4d07-89d2-77f722d7c611",
						"text": "Risk Mitigation",
						"numFirstSelections": 0
					},
					{
						"id": "ebd92289-25f6-4eea-8aa5-c7ca0813d957",
						"text": "Objectivity and Neutrality Are Maintained",
						"numFirstSelections": 0
					},
					{
						"id": "9e5a8480-ad4f-42cf-939a-03dac1f9fb78",
						"text": "Ensuring Student Welfare",
						"numFirstSelections": 0
					},
					{
						"id": "86f03ac2-7fa0-4d13-b873-16f514071ef3",
						"text": "Transparency in Actions and Communications",
						"numFirstSelections": 0
					},
					{
						"id": "aae9df86-3dfb-4ef6-9686-3a5e19fb6375",
						"text": "Honoring the Boundaries of Role, Time, and Place",
						"numFirstSelections": 0
					},
					{
						"id": "afa84a0d-bc22-4198-9030-85d3cffb3e1e",
						"text": "Integrity of the Profession Is Promoted by the Educator",
						"numFirstSelections": 0
					},
					{
						"id": "25bd0079-3074-4589-82a5-a1e34d5848c5",
						"text": "Code of Ethics for Educators Is Maintained with Fidelity",
						"numFirstSelections": 0
					},
					{
						"id": "ef057765-9e96-4469-8528-3b03b224b1b5",
						"text": "Stewardship of the Law and Public Trust",
						"numFirstSelections": 0
					}
				],
				"shuffle": false
			},
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103762,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "You will review three videos that show an educator’s interaction with a student and what happens because of the educator’s choices.\n\nAfter observing the videos, you will reflect on and explore the ethical dilemmas depicted in the scenario.",
				"media": [
					{
						"type": "VIDEO",
						"title": "Waiting With Jordan",
						"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-8/m8o3_waiting_with_jordan.mp4",
						"transcript": "**Module 8 – The Ride Home: Outcome 3**\n\n**Video 1: Waiting with Jordan**\n\nThe video shows a high school sports complex at night. A teacher is standing out front after locking up.\n\nMr. Morales: [voiceover]. It’s later than I expected. The weather delays pushed the track event back, and now everyone else has already left.\n\n[A student approaches Mr. Morales.]\n\nJordan [anxiously]: My ride never showed up. I’ve been calling my mom, but she’s not answering. I don’t know what to do. All my friends already left. Can you help me get home?\n\nMr. Morales: Thank you for telling me, Jordan. I’m not going to leave you here. Let’s try calling your mom together.\n\n[Mr. Morales reaches into his pocket, pulls out his phone, and calls Jordan’s mother, but there is no answer.]\n\nAutomated voice [from the phone call]: The person you are calling is not available. Please leave a message.\n\nMr. Morales: Okay. Do you have another emergency contact?\n\nJordan: My aunt, but she’s not answering either.\n\n[Mr. Morales calls a contact in his phone and the person answers.]\n\nMr. Morales: Hi, Assistant Principal Thomas, this is Mr. Morales. I’m still at school with a student who doesn’t have a ride home. I’ve tried contacting her family but haven’t reached anyone. Could you come help?\n\nAssistant Principal Thomas [from the phone call]: I’ll be right there.\n\nMr. Morales: Thank you! We’ll wait outside.\n\n[Mr. Morales puts his phone back in his pocket.]\n\nMr. Morales: You did the right thing by asking for help.\n\n[Jordan smiles, looking relieved.]",
						"transcriptTitle": "Transcript for Waiting With Jordan video",
						"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
					},
					{
						"type": "VIDEO",
						"title": "Safe Transportation",
						"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-8/m8o3_safe_transportation.mp4",
						"transcript": "**Module 8 – The Ride Home: Outcome 3**\n\n**Video 2: Safe Transportation**\n\nThe video shows two scenes. The first scene takes place at a high school sports complex at night. Mr. Morales and Jordan are standing outside with Assistant Principal Thomas.\n\nAssistant Principal Thomas: Hi, Jordan. Hi, Mr. Morales. I’m glad you called.\n\nMr. Morales: Thank you for coming, Mr. Thomas.\n\nAssistance Principal Thomas: Jordan, we’ll get you home safely.\n\n[Mr. Morales, Jordan, and Assistant Principal Thomas walk towards a car in the parking lot.]\n\nThe second scene takes places in Mr. Thomas’ car. Mr. Morales, Jordan, and Mr. Thomas are in the car. They arrive at Jordan’s house. The porch light is on at the house.\n\nAssistant Principal Thomas: You can go inside, Jordan.\n\n[Jordan waves and walks toward the front door. Mr. Morales and Mr. Thomas wave.]\n\nAssistant Principal Thomas: I’ll document this and follow up with the family tomorrow.\n\nMr. Morales: Thank you. I appreciate the support.",
						"transcriptTitle": "Transcript for Safe Transportation video",
						"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
					},
					{
						"type": "VIDEO",
						"title": "Honest Disclosure",
						"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-8/m8o3_honest_disclosure.mp4",
						"transcript": "**Module 8 – The Ride Home: Outcome 3**\n\n**Video 3: Honest Disclosure**\n\nThe video shows Jordan’s mother arriving home later that evening. She has a conversation with Jordan.\n\nMother: Jordan, I’m home.\n\n[Jordan joins her mother in the dining area.]\n\nMother: I’m sorry I missed your calls. I tried calling you back when I left work. Is everything OK?\n\nJordan: My ride didn’t show up.\n\nMother: How did you get home tonight?\n\nJordan: Mr. Morales stayed with me and called Assistant Principal Thomas. They both brought me home.\n\nMother: I’m glad you weren’t alone. Thank you for telling me. That sounds like they handled it the right way.",
						"transcriptTitle": "Transcript for Honest Disclosure video",
						"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
					}
				],
				"title": "The Ride Home: Outcome 3",
				"instruction": "**Directions:** Select each of the following three tabs to review the videos. Select the play button in each tab to begin. Use the video controls when needed."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_presentation",
				"language": "en-US",
				"position": 11,
				"sourceId": 8110
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103763,
			"versionId": 1,
			"blockId": null,
			"type": "SATA",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "The second step in navigating ethical dilemmas is exploring the risks to the ethical principles.",
				"title": "Outcome 3: Explore",
				"question": "Which of the following ethical principles were at immediate risk for Mr. Morales in this last scenario? Select all that apply.",
				"instruction": "**Directions:** Select each of the following nine expandable text buttons to review information about each principle of ethical decision making.",
				"ethicalPrinciples": {
					"items": [
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-01-promoting-solution-discovery-illustration-v2.png"
								}
							],
							"title": "**P**romoting Solution Discovery",
							"description": "Creating opportunities for self-advocacy and problem resolution is a foundational principle in ethical decision making. Educators should refer students or colleagues to suitable school resources and officials and ensure that these students and colleagues follow up, rather than handle issues themselves. Not only is this in the best interest of those involved, but it also allows situations to be handled objectively and avoids blurring the scope of the educator’s position with that of more expansive roles such as those of counselor, confidant, caregiver, and rescuer. The primary role of the professional educator is most often associated with the tasks of teaching and learning.\n\n**Guiding Questions**\n- What are the inherent professional risks in attempting to fix the immediate or long-term challenges, problems, and obstacles that students, colleagues, or other learning community stakeholders encounter?\n- Am I accepting responsibilities, performing duties, or providing services that correspond with my training and area of certification?\n- How can I help colleagues when their role as a professional educator overlaps with other societal expectations?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-02-risk-mitigation-illustration-v2.png"
								}
							],
							"title": "**R**isk Mitigation",
							"description": "Since educators provide services directly to minors who remain under their care and supervision for extended periods of time without the presence of parents or guardians, the field of education has many professional risks and vulnerabilities. It is important that all educators continually reflect on how to best mitigate risks that may compromise their professional and personal credibility, career goals, personal well-being, and effectiveness as a teacher.\n\n**Guiding Questions**\n- How can a seemingly innocuous and insignificant decision have the potential to put my educational practice at risk?\n- What professional-risk situations inherent in my educational practice do I need to carefully consider (for example, chaperoning an overnight field trip, being approached by a student for personal advice)?\n- What conversations can I have with my colleagues to help identify ways to mitigate risks in situations that we commonly encounter?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-03-objectivity-neutrality-maintained-illustration-v3.png"
								}
							],
							"title": "**O**bjectivity and Neutrality Are Maintained",
							"description": "By maintaining objectivity and neutrality, professional educators should be able to evaluate a situation without emotional entanglements or bias. Remaining objective and neutral mitigates the risks of over-identifying with one party, becoming too focused on the needs of an individual, or advocating for a singular interest instead of advocating for solutions.\n\n**Guiding Questions**\n- When encountering competing tensions (for example, school policy versus what I think is best for a student or colleague; parental influence versus administrative influence), how can I determine the best course of action?\n- How can I remain objective and neutral when I have multiple relationships in the schooling community and as a community member (for example, I’m a friend of one of my student’s parents; I am a youth group leader at a student’s religious center; I coach a student on a club volleyball team during the summer)?\n- How can I best caution a colleague if I suspect the colleague is becoming overwhelmed by the needs of a student?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-04-ensuring-student-welfare-illustration-v2.png"
								}
							],
							"title": "**E**nsuring Student Welfare",
							"description": "Since the individuals receiving services are minors and the educators have been ascribed in loco parentis responsibilities, the primary responsibility of educators is to ensure the students’ safety and welfare. The scope of this charge is not just limited to physical safety, but it also includes emotional, intellectual, psychological, and sexual safety.\n\n**Guiding Questions**\n- Am I doing everything in my power to establish a safe and secure environment for academic, personal, and social growth to occur?\n- Am I willing to safeguard students from duress even if I am not directly responsible for the students?\n- How can I best confront a colleague regarding acts, either committed or omitted, that have the potential to compromise a student’s welfare?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-05-transparency-actions-communications-illustration-v2.png"
								}
							],
							"title": "**T**ransparency in Actions and Communications",
							"description": "Educators must be transparent in their actions and communications. Transparency establishes openness, accountability, trust, credibility, and boundaries. Failure to be sufficiently transparent with appropriate stakeholders (for example, parents, guardians, students, colleagues, administrators) may result in misinterpretation of motives or the appearance of impropriety. Transparency is the best way for educators to ensure that their decisions and behaviors can withstand public scrutiny.\n\n**Guiding Questions**\n- How can I ensure that all communications with students, including digital and electronic communications, are conducted with transparency?\n- How can I balance the need for transparency in my actions and communications with protecting highly confidential information that I am expected to retain (which is considered a “qualified privilege” by the courts)?\n- How do I best approach a colleague about rumors of impropriety that are a result of their lack of transparency in decision making?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-06-boundaries-role-time-place-illustration-v2.png"
								}
							],
							"title": "**H**onoring the Boundaries of Role, Time. and Place",
							"description": "Boundaries encompass the verbal, physical, emotional, and social distances that an educator must maintain to ensure security, structure, and predictability in an educational environment. Most often, the boundaries that are transgressed relate to role, time, and place. By respecting the functions and limits of contracted roles, as well as the working hours and location of the learning environment, secure boundaries are in place for all members of the school community.\n\n**Guiding Questions**\n- In reflecting on my educational practice, which dispositions most risk eroding professional boundaries (for example, assisting with students’ personal challenges, extending academic support beyond school hours, engaging in extracurricular activities, communication with students, parents, and colleagues)?\n- Am I thinking about all my interactions with students (for example, in the school, in the community, and at social functions) as an extension of my professional responsibilities as an educator?\n- How can my colleagues and I openly discuss and agree on boundaries that are most appropriate for our educational context?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-07-integrity-profession-illustration-v2.png"
								}
							],
							"title": "**I**ntegrity of the Profession Is Promoted by the Educator",
							"description": "Educators’ actions reflect on the schooling community, the district, and the profession. An individual educator’s positive actions have the potential to inspire public confidence in the profession. On the other hand, negative actions can cast shadows of doubt and distrust by undermining the effectiveness of a healthy educational structure. The professional educator has an obligation to hold himself or herself responsible for ethical conduct. The educator should take steps when he or she has reason to believe that another educator may be approaching or engaged in an ethically compromising situation.\n\n**Guiding Questions**\n- How often am I reflecting on the daily decisions that I make as a professional educator and how those decisions may affect the integrity of the profession?\n- What steps can I take when I believe that a colleague may be approaching or involved in an ethically compromising situation?\n- How can I best advocate for the profession while also working to reconcile points of disagreement within the school or district?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-08-code-ethics-fidelity-illustration-v2.png"
								}
							],
							"title": "**C**ode of Ethics for Educators Is Maintained with Fidelity",
							"description": "Having an ethics code is a proclamation that a profession is better off when ethical standards are not based solely on individual assessments of what is or is not ethically acceptable but reflect consensus among members on a common purpose. For the education discipline, the *Model Code of Ethics for Educators* (*MCEE*) is a guide for what educators should expect of themselves and one another and should be maintained with fidelity. The *MCEE* assists educators in their efforts to resolve ethical dilemmas and helps educators defend their decisions to schooling-community constituents, institutions, courts, and any other agency that would encourage them to go against the values of the profession. The formal standards are not a substitute for an active, deliberate, and creative approach to fulfilling your ethical responsibilities. They prompt, guide, and inform an educator’s ethical decision-making; they do not serve as a substitute for it.\n\n**Guiding Questions**\n- How can educators from my school or district work together to identify common ethical dilemmas that we encounter?\n- Is there a way to use the *MCEE* as a prompt to discuss resolutions to those ethical dilemmas?\n- Since ethical dilemmas are often situational, contextual, and likely to change over time, how can the *MCEE* continue to guide and inform my decision making as I engage in the practical realities of my work?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"
								}
							],
							"title": "**S**tewardship of the Law and Public Trust",
							"description": "Employment policies, licensure statutes, and community laws represent conduct absolutes that have originated from a history of judicial activity. They represent the lowest standard of acceptable behavior deemed necessary to safeguard community members. However, the professional educator is aware that trust in the profession depends on a level of conduct and responsibility that may be higher than what is required by law.\n\n**Guiding Questions**\n- How will relevant procedures, policies, and laws inform my decision making when I encounter ethical dilemmas?\n- It has been said that misconduct is not an event but a process. Will I be able to identify those situations where a series of gradual and unintentional missteps could lead to the transgression of a conduct absolute?\n- What steps can I take when I believe that a colleague may be approaching or involved in actions that may lead to the transgression of a policy, statute, or law?"
						}
					],
					"title": "Ethical Principles"
				}
			},
			"metadata": {
				"type": "SATA",
				"ui_type": "scenario_principle_sata_activity",
				"language": "en-US",
				"position": 13,
				"sourceId": 8130
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "0cba2519-9710-4234-bc65-42df7ffe8ddc",
						"isCorrect": false
					},
					{
						"choiceId": "7ec6b06f-972c-4935-a9b4-446f5ec5c103",
						"isCorrect": false
					},
					{
						"choiceId": "f67bf7a4-64e6-4569-a85b-7b8d0e61ee15",
						"isCorrect": false
					},
					{
						"choiceId": "3ac0391d-60d1-4f05-9bf9-e866a6a328bf",
						"isCorrect": false
					},
					{
						"choiceId": "0d0f26d4-5baf-4740-b8d7-b30356777540",
						"isCorrect": false
					},
					{
						"choiceId": "ce4de2d7-5eab-4542-aecc-26255282fdcd",
						"isCorrect": false
					},
					{
						"choiceId": "73766bd1-e8cd-42f0-a21e-2305d1f0d5bd",
						"isCorrect": false
					},
					{
						"choiceId": "b25abd8d-463e-474f-ba64-21fd912e0fdf",
						"isCorrect": false
					},
					{
						"choiceId": "11e704ed-366a-4a5f-b1a3-3985b18ceb93",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 9,
					"min": 1
				}
			},
			"feedback": null,
			"response": {
				"type": "MULTIPLE_SELECT",
				"choices": [
					{
						"id": "0cba2519-9710-4234-bc65-42df7ffe8ddc",
						"text": "Promoting Solution Discovery",
						"numFirstSelections": 0
					},
					{
						"id": "7ec6b06f-972c-4935-a9b4-446f5ec5c103",
						"text": "Risk Mitigation",
						"numFirstSelections": 0
					},
					{
						"id": "f67bf7a4-64e6-4569-a85b-7b8d0e61ee15",
						"text": "Objectivity and Neutrality Are Maintained",
						"numFirstSelections": 0
					},
					{
						"id": "3ac0391d-60d1-4f05-9bf9-e866a6a328bf",
						"text": "Ensuring Student Welfare",
						"numFirstSelections": 0
					},
					{
						"id": "0d0f26d4-5baf-4740-b8d7-b30356777540",
						"text": "Transparency in Actions and Communications",
						"numFirstSelections": 0
					},
					{
						"id": "ce4de2d7-5eab-4542-aecc-26255282fdcd",
						"text": "Honoring the Boundaries of Role, Time, and Place",
						"numFirstSelections": 0
					},
					{
						"id": "73766bd1-e8cd-42f0-a21e-2305d1f0d5bd",
						"text": "Integrity of the Profession Is Promoted by the Educator",
						"numFirstSelections": 0
					},
					{
						"id": "b25abd8d-463e-474f-ba64-21fd912e0fdf",
						"text": "Code of Ethics for Educators Is Maintained with Fidelity",
						"numFirstSelections": 0
					},
					{
						"id": "11e704ed-366a-4a5f-b1a3-3985b18ceb93",
						"text": "Stewardship of the Law and Public Trust",
						"numFirstSelections": 0
					}
				],
				"shuffle": false
			},
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103764,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "",
				"items": [
					{
						"title": "Outcome 1",
						"analysis": {
							"text": "**Acting Alone to Solve the Problem**\n\n**Mr. Morales’ Priorities**\n\nMr. Morales prioritized compassion and immediate problem‑solving over other concerns. He was probably influenced by a personal belief that a caring adult should step in when a student is distressed.\n\n**Implications of That Decision**\n- Jordan arrives home safely, but professional boundaries are crossed.\n- The lack of transparency leads Jordan to feel pressured to lie to her parent.\n- Because Mr. Morales asked Jordan not to tell anyone, when Jordan’s mother finds out what happened, the ethical, professional, and reputational risks for Mr. Morales increase.\n- Good intentions inadvertently increase vulnerability for both the student and educator.",
							"title": "Analysis"
						},
						"questions": {
							"text": "The following are reflective questions Mr. Morales could ask himself.\n- Am I acting because this feels urgent or because this is the most ethical option?\n- What could happen if this decision is discovered later?\n- How might this action blur my professional role?",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Good intentions do not eliminate ethical risk.** Acting alone, even with compassion, can create hidden consequences that emerge after the immediate problem seems resolved.",
							"title": "Key Takeaway"
						}
					},
					{
						"title": "Outcome 2",
						"analysis": {
							"text": "**Avoiding Risk by Declining Help**\n\n**Mr. Morales’ Priorities**\n\nMr. Morales prioritized protecting professional boundaries and minimizing personal risk over other concerns, focusing on what he should not do rather than on what he should do.\n\n**Implications of That Decision**\n- Mr. Morales avoids a boundary violation, but student welfare is compromised.\n- Jordan is intimidated and emotionally distressed while alone in a public setting.\n- Risk is shifted from the educator to the student rather than mitigated.\n- The situation escalates despite Mr. Morales’ compliance‑focused decision.",
							"title": "Analysis"
						},
						"questions": {
							"text": "The following are reflective questions Mr. Morales could ask himself.\n- Does declining help resolve the ethical dilemma or simply transfer risk?\n- What foreseeable risks could Jordan encounter if left alone?\n- Who else should be involved to ensure student safety without violating boundaries?",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Maintaining boundaries is essential, but ethical responsibility does not end with saying “no.”** Avoiding one risk without addressing student safety creates new ethical concerns.",
							"title": "Key Takeaway"
						}
					},
					{
						"title": "Outcome 3",
						"analysis": {
							"text": "**Sharing Responsibility**\n\n**Mr. Morales’ Priorities**\n\nMr. Morales made student welfare, transparency, and shared responsibility priorities, using school procedures and administrative support to guide his actions.\n\n**Implications of That Decision**\n- Jordan remains supervised and supported at all times.\n- Professional boundaries are respected and documented.\n- Parent receives accurate information, reinforcing trust.\n- Risk is reduced for both the student and educator by seeking collaboration.",
							"title": "Analysis"
						},
						"questions": {
							"text": "The following are reflective questions Mr. Morales could ask himself.\n- Who is best equipped to help in this situation?\n- How can I ensure this decision is transparent and defensible?\n- Am I balancing care for the student with adherence to professional standards?",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Ethical decision making is strongest when care is paired with collaboration.** Involving others, following procedures, and sharing responsibility when making decisions about students helps reduce the ethical risk to educators and the profession.",
							"title": "Key Takeaway"
						}
					}
				],
				"title": "The Ride Home: Analysis",
				"instruction": "**Directions:** Select each of the following three tabs to explore the analysis of each outcome for The Ride Home scenario. Select each of the expandable text buttons within each tab to review the information about each outcome."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_analysis_cards",
				"language": "en-US",
				"position": 15,
				"sourceId": 8150
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103765,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Your school gives guidelines about how much material your students should learn in a given year. District exams are given quarterly and are used to compare student performance across schools, so it is important that your students do well on the exams. While monitoring the students taking the district exam, you notice that one of your students has marked an answer that you know is incorrect.\n\nBased on what you have learned in this course, which of the following is the best way to respond to this situation?"
				},
				"title": "Knowledge Check Question 4"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 20,
				"sourceId": 8200
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "45cc9897-e1d0-43b3-bba2-c303234163ea",
						"isCorrect": false
					},
					{
						"choiceId": "9406ed1a-20a5-4997-92d7-01fe00e2d829",
						"isCorrect": false
					},
					{
						"choiceId": "744c5a49-06ae-4410-83d9-d7bd56eb944e",
						"isCorrect": true
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "744c5a49-06ae-4410-83d9-d7bd56eb944e",
					"detailed": {
						"text": "During a test, the teacher’s role is to monitor, not to assist. Even suggesting that a student check their answer gives that student an unfair advantage and affects the integrity of the exam."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "45cc9897-e1d0-43b3-bba2-c303234163ea",
						"text": "Tell the student the answer is incorrect.",
						"numFirstSelections": 0
					},
					{
						"id": "9406ed1a-20a5-4997-92d7-01fe00e2d829",
						"text": "Advise the student to double-check his or her work.",
						"numFirstSelections": 0
					},
					{
						"id": "744c5a49-06ae-4410-83d9-d7bd56eb944e",
						"text": "Continue to walk around the room and monitor the students taking the exam.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103766,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "A high school teacher wants to communicate with students outside of school hours about coursework and assignments.\n\nWhich of the following actions best aligns with ethical responsibilities and appropriate professional boundaries?"
				},
				"title": "Knowledge Check Question 1"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 17,
				"sourceId": 8170
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "660fea85-ee10-4f87-9e9b-c7d5aed55842",
						"isCorrect": true
					},
					{
						"choiceId": "4eded121-7910-4168-9bdd-451fef76af9c",
						"isCorrect": false
					},
					{
						"choiceId": "d844c50d-826e-4432-9f28-e05a6ebb62e6",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "660fea85-ee10-4f87-9e9b-c7d5aed55842",
					"detailed": {
						"text": "Communicating with students through school-approved platforms or communication systems helps ensure that interactions remain professional, transparent, and consistent with established policies. These systems are designed to maintain appropriate boundaries, provide oversight when needed, and protect both students and educators from situations that could be perceived as inappropriate."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "660fea85-ee10-4f87-9e9b-c7d5aed55842",
						"text": "Communicating with students through school-approved platforms or communication systems",
						"numFirstSelections": 0
					},
					{
						"id": "4eded121-7910-4168-9bdd-451fef76af9c",
						"text": "Exchanging personal e-mail addresses with students to allow more flexible communication",
						"numFirstSelections": 0
					},
					{
						"id": "d844c50d-826e-4432-9f28-e05a6ebb62e6",
						"text": "Using personal text messaging to send information directly to students",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103767,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "A teacher learns that the principal has submitted the teacher’s evaluation, even though the principal did not observe the teacher during the school year. The evaluation indicates that an observation occurred on a day when the teacher was not present in the building.\n\nWhich of the following actions best aligns with ethical responsibilities and professional conduct?"
				},
				"title": "Knowledge Check Question 3"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 19,
				"sourceId": 8190
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "5786b7a5-2c2c-4d6e-9665-04bb5740e943",
						"isCorrect": false
					},
					{
						"choiceId": "7aaba470-0667-4c93-ad5d-a6305b0d0541",
						"isCorrect": false
					},
					{
						"choiceId": "a43ec1fb-5ea5-4327-8f94-a7e4cdfd3b70",
						"isCorrect": true
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "a43ec1fb-5ea5-4327-8f94-a7e4cdfd3b70",
					"detailed": {
						"text": "Educators are expected to address concerns about inaccurate or misleading information through proper channels in a respectful and solution-oriented manner. By seeking clarification directly from the principal, the teacher promotes transparency, helps ensure the integrity of the evaluation process, and upholds professional standards within the school community."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "5786b7a5-2c2c-4d6e-9665-04bb5740e943",
						"text": "Informing colleagues that the evaluation was inaccurate",
						"numFirstSelections": 0
					},
					{
						"id": "7aaba470-0667-4c93-ad5d-a6305b0d0541",
						"text": "Taking no action because evaluations cannot be changed once submitted",
						"numFirstSelections": 0
					},
					{
						"id": "a43ec1fb-5ea5-4327-8f94-a7e4cdfd3b70",
						"text": "Meeting with the principal to discuss the discrepancy and request clarification or correction",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103768,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "A student who was previously in a teacher’s class frequently visits the teacher before school, during lunch, and after school to talk.\n\nWhich of the following responses best aligns with ethical responsibilities and appropriate professional boundaries?"
				},
				"title": "Knowledge Check Question 2"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 18,
				"sourceId": 8180
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "e1da6de3-1e4d-4a68-91fa-f78b904f4e97",
						"isCorrect": true
					},
					{
						"choiceId": "9c7a0082-0d23-4583-a4d3-a4e7b4c12f6b",
						"isCorrect": false
					},
					{
						"choiceId": "15ea42e2-4090-4c59-802f-91951acb0990",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "e1da6de3-1e4d-4a68-91fa-f78b904f4e97",
					"detailed": {
						"text": "Speaking with the student at appropriate times within the school setting and maintaining professional boundaries allows the teacher to remain supportive while upholding ethical responsibilities. By establishing clear boundaries, the teacher reduces the risk of favoritism or the appearance of impropriety while still providing appropriate guidance and support to the student."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "e1da6de3-1e4d-4a68-91fa-f78b904f4e97",
						"text": "Speaking with the student briefly when appropriate while maintaining professional boundaries",
						"numFirstSelections": 0
					},
					{
						"id": "9c7a0082-0d23-4583-a4d3-a4e7b4c12f6b",
						"text": "Arranging to meet the student outside of school to allow more time for discussion",
						"numFirstSelections": 0
					},
					{
						"id": "15ea42e2-4090-4c59-802f-91951acb0990",
						"text": "Refusing to speak with the student because the student is no longer enrolled in the teacher’s class",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103769,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "**Why Ethical Judgment Matters: Considering Short‑Term and Long‑Term Outcomes**\n\nEthical decision making in education is rarely about choosing between clearly right and clearly wrong actions. More often, it involves navigating situations where multiple values are in tension, such as care for students, professional boundaries, transparency, and accountability. Decisions made under pressure can appear to resolve an immediate concern but can create unintended long‑term consequences.\n\nAcross the three outcomes of The Ride Home scenario, you saw the following.\n- How actions influenced solely by providing an immediate solution can lead to boundary violations and delayed ethical risk.\n- How decisions focused solely on self-protection can cause educators to overlook rules and can shift risk onto students.\n- How ethical judgment is strongest when educators slow down and fully assess the situation, anticipate ripple effects, and rely on shared standards rather than instinct alone.\n\nConsidering both short‑term and long‑term outcomes helps educators avoid the false sense of resolution that occurs when a problem seems solved in the moment but resurfaces later through loss of trust, harm to student welfare, or professional scrutiny. Ethical professionalism requires thinking beyond “Does this work right now?” to “How will this decision hold up over time, and to whom am I accountable?”\n\n**Applying Ethical Decision Making in Your Own Practice**\n\nApplying ethical decision making is not about memorizing rules; it is about building habits of reflection and restraint. Ethical professionalism means knowing when a situation exceeds your role, training, or authority and intentionally involving others who are better equipped to help.\n\nTo apply what you learned, follow these guidelines.\n- Pause when a situation feels urgent or emotionally charged.\n- Identify which ethical principles are at risk, not just which rules apply.\n- Balance dispositional instincts (such as, care, empathy, and responsiveness) with regulatory guidance (such as policies, procedures, and professional standards).\n- Use transparency and shared responsibility to protect students and yourself.\n- Recognize that ethical decision making often means not acting alone, even when your intentions are good.\n\nEthical decision making is a skill developed over time. By practicing ethical reflection consistently, you strengthen your effectiveness as an educator, safeguard student welfare, and contribute to the long‑term trust placed in the teaching profession.\n\n**Self-Reflection Prompts**\n\nReflect on how the lessons from Module 8 apply to your own role, school environment, and responsibilities by using the following prompts.\n- What situations in my school or district are most likely to place me in a time‑pressured ethical dilemma?\n- When I feel compelled to fix a problem quickly, what ethical principles might I be overlooking?\n- Instead of acting alone, what policies, procedures, or colleagues could support me?\n- How do after‑school activities, extracurricular roles, or informal interactions affect my professional boundaries?\n- If my decision is reviewed by a parent, administrator, or licensing body, how would I explain my reasoning?\n- How can I ensure that my actions with students promote safety, transparency, and trust, even when no one else is watching?\n\nThese questions are designed to help you recognize patterns in your own decision making and identify moments when ethical reflection is most needed.",
				"title": "Module 8 Summary"
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "module_summary",
				"language": "en-US",
				"position": 16,
				"sourceId": 8160
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103770,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Liza, one of your middle school students, tells you a story about her mother’s boyfriend touching her in inappropriate ways. You are not sure you believe Liza.\n\nBased on what you have learned in this course, which of the following is the best way to respond to this situation?"
				},
				"title": "Knowledge Check Question 5"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 21,
				"sourceId": 8210
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "81e1bd3b-01eb-44e5-bd24-8b91b31b2cf5",
						"isCorrect": false
					},
					{
						"choiceId": "790c38ef-80c2-4e6f-a63a-87568b26293d",
						"isCorrect": true
					},
					{
						"choiceId": "0c0627fa-305b-4c4b-a871-ae3313a79efa",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "790c38ef-80c2-4e6f-a63a-87568b26293d",
					"detailed": {
						"text": "Educators have a duty to report suspected child abuse immediately. To ensure students’ safety, educators do not need to wait until they are one hundred percent certain of abuse before reporting it. It is also best to leave formal investigation and intervention to professionals who have the training and legal authority to properly address these situations."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "81e1bd3b-01eb-44e5-bd24-8b91b31b2cf5",
						"text": "Contact Liza’s mother directly.",
						"numFirstSelections": 0
					},
					{
						"id": "790c38ef-80c2-4e6f-a63a-87568b26293d",
						"text": "Report the information to the administration at your school.",
						"numFirstSelections": 0
					},
					{
						"id": "0c0627fa-305b-4c4b-a871-ae3313a79efa",
						"text": "Do nothing about what Liza told you.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37094,
					"label": "Module 8: Ethical Decision Making for the Professional Educator",
					"title": "Module 8: Ethical Decision Making for the Professional Educator",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		}
	],
	"examName": "Module 8: Ethical Decision Making for the Professional Educator",
	"sessionSubType": "PRACTICE_TEST",
	"publicId": "f9881fe1-cf01-4463-be00-092c891a23fd",
	"sessionType": "SUMMATIVE",
	"totalTime": null
}
